import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ContactDetail } from '@/components/finance/contacts';

// Contact detail mounts at the top level alongside the Contacts primary tab.
export const Route = createFileRoute('/admin/finance/contacts/$contactId')({
  // Inline Resolve for MissingDonorInfo routes here with `focus=missing` so the
  // drawer can scroll/focus the first missing field.
  validateSearch: (search: Record<string, unknown>): { focus?: 'missing' } => ({
    focus: search.focus === 'missing' ? 'missing' : undefined,
  }),
  component: ContactDetailRoute,
});

function ContactDetailRoute() {
  const { contactId } = Route.useParams();
  const navigate = useNavigate();

  return (
    <ContactDetail
      contactId={contactId}
      onBack={() => navigate({ to: '/admin/finance/contacts' })}
    />
  );
}
